import { FilterOptionType } from "components/Filter/Filter.type";

export const setFilterQuery = (title: string, options: FilterOptionType[], setSearchParam: (title: string, value: string) => void) => {
  const checkedOptions = options.filter(i => i.checked).map(i => { return i.value }).join(',');
  setSearchParam(title, checkedOptions);
}